import requestWrapper from '@api';
import { setHeaders } from '@helpers/api/setHeaders';
import { keysToCamel } from '@helpers/camelCaseConverter';

export { default as axiosInstance } from './axiosInstance';
export { default as deleteRequest } from './delete';
export { downloadRequest } from './download';
export { default as getRequest } from './get';
export { default as postRequest } from './post';
export { default as patchRequest } from './patch';
export { default as putRequest } from './put';

/**
 * Creates an API call with the request
 * @deprecated
 * @param {function} request API call. Uses dependency injection in request wrapper to add agent
 * @param {Object} additionalConfig Extra config to pass to Axios
 * @returns {Promise} API call using agent
 *
 * @example callApi(agent => (payload) => agent.post('api/route', payload))
 */
export const callApi = (request, additionalConfig = {}) => {
  const config = { headers: setHeaders(), ...additionalConfig };
  return request(requestWrapper(config));
};

/**
 * Returns response data converted to camel case
 * @deprecated
 * @param {Object} response Api response
 * @param {*} response.data Data portion of API response
 * @returns {*} Camel-cased data
 */
export const handleResponse = response => {
  response = keysToCamel(response);
  return response.data;
};

/**
 * Returns the data portion of the error response from axios
 * @deprecated
 * @param {obj} error Error response
 * @param {obj} error.response API error response
 * @param {*} error.response.data Data portion of API response
 */
export const handleError = error => error?.response?.data || {};

export default callApi;
